import { render } from "./PayPeriod.vue?vue&type=template&id=32bc15d6"
import script from "./PayPeriod.vue?vue&type=script&lang=js"
export * from "./PayPeriod.vue?vue&type=script&lang=js"

import "./PayPeriod.vue?vue&type=style&index=0&id=32bc15d6&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__